import React from 'react';

const Info = ({ props }) => (
  <div className="event__info">

    <h3>{ `Starts At: ${props.startsAt}` }</h3>

    <div>
      <span>{props.awayTeam}</span>
      <span> @ </span>
      <span>{props.homeTeam}</span>
    </div>
  </div>

);

export default Info;
